import { render, staticRenderFns } from "./DeletePerform.vue?vue&type=template&id=c62f48e0&scoped=true"
import script from "./DeletePerform.vue?vue&type=script&lang=js"
export * from "./DeletePerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f48e0",
  null
  
)

export default component.exports